import { createSlice } from '@reduxjs/toolkit'
import {
  getStudentCourseDetails,
  getStudentPaymentDetails,
  getStudentProfile,
  postExamAnswer,
  studentStartExam,
} from '../../builders/student/student.builder'

const initialState = {
  studentId: '',
  loading: false,
  studentInformation: '',
  studentAcademicDetails: [],
  studentCourseDetails: [],
  studentPaymentDetails: [],
  studentOnlineExamQuestions: [],
  examRemainingTime: null,
}

const studentSlice = createSlice({
  name: 'student',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getStudentProfile.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getStudentProfile.fulfilled, (state, action) => {
      state.loading = false
      state.studentInformation = action.payload
      state.studentId = action.payload && action.payload[0]?.studentId
      state.studentAcademicDetails = action.payload && action.payload[0]?.academicDetails
    })
    builder.addCase(getStudentProfile.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(getStudentCourseDetails.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getStudentCourseDetails.fulfilled, (state, action) => {
      state.loading = false
      state.studentCourseDetails = action.payload
    })
    builder.addCase(getStudentCourseDetails.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(getStudentPaymentDetails.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getStudentPaymentDetails.fulfilled, (state, action) => {
      state.loading = false
      if (action.payload) state.studentPaymentDetails = [...action.payload]
    })
    builder.addCase(getStudentPaymentDetails.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(studentStartExam.pending, (state) => {
      state.loading = true
    })
    builder.addCase(studentStartExam.fulfilled, (state, action) => {
      state.studentOnlineExamQuestions = action.payload
      state.loading = false
    })
    builder.addCase(studentStartExam.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(postExamAnswer.pending, (state) => {
      state.loading = true
    })
    builder.addCase(postExamAnswer.fulfilled, (state, action) => {
      state.examRemainingTime = action.payload
      state.loading = false
    })
    builder.addCase(postExamAnswer.rejected, (state) => {
      state.loading = false
    })
  },
})

// export const {} = studentSlice.actions

export default studentSlice.reducer
